import { catchError, forkJoin, Observable, of } from "rxjs";
import NetworkService from "../network/networkService";
import { helperFunctions } from "../helper/helper";
import { AgTechQueryParam } from "../enums/AgTechQueryParams.enum";
import {
  IProduct,
  IProductAllResponse,
  IProductAttributesAllResponse,
  IProductCategoryAllResponse,
} from "../models/IProduct.model";
import { URLConfig } from "../network/urlStore";
import { OdQueryParam } from "../enums";

export const getProducts = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<IProductAllResponse> => {
  let url = URLConfig.getProductsMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (productResponse: unknown) => {
        if (productResponse) {
          const productsResponse =
            productResponse as unknown as IProductAllResponse;
          subscriber.next(productsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching products master data", error);
      }
    );
  });
};

export const getProductsNextPage = (
  nextPageURI: string
): Observable<IProductAllResponse> => {
  let url = URLConfig.getProductsNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (productResponse) => {
        if (productResponse) {
          const productsResponse =
            productResponse as unknown as IProductAllResponse;
          subscriber.next(productsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching products master data", error);
      }
    );
  });
};

export const createProduct = (requestPayload: any): Observable<any> => {
  let url = URLConfig.getProductsMasterDataURL();

  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getContentLengthForProduct = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getProductsMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const updateProduct = (
  productPayload: any,
  productId: string
): Observable<any> => {
  let url = URLConfig.updateProductsMasterDataURL(productId);

  return new Observable((subscriber) => {
    NetworkService.patch(url, productPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating field", error);
      }
    );
  });
};

export const getProductAttributes = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IProductAttributesAllResponse> => {
  let url = URLConfig.getProductsAttributeMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (productResponse: unknown) => {
        if (productResponse) {
          const productsResponse =
            productResponse as unknown as IProductAttributesAllResponse;
          subscriber.next(productsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log(
          "Error while fetching products attribute master data",
          error
        );
      }
    );
  });
};

export const getProductCategory = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IProductCategoryAllResponse> => {
  let url = URLConfig.getProductsCategoryMasterDataURL();

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (productResponse: unknown) => {
        if (productResponse) {
          const productsCatResponse =
            productResponse as unknown as IProductCategoryAllResponse;
          subscriber.next(productsCatResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log(
          "Error while fetching products attribute master data",
          error
        );
      }
    );
  });
};

export const deleteProduct = (productId: string, queryParams?: Array<{
  key: AgTechQueryParam;
  value: boolean[] | string[];
}>): Observable<IProduct> => {
  let url = URLConfig.updateProductsMasterDataURL(productId);

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (productResponse: unknown) => {
        const productsCatResponse = productResponse as unknown as IProduct;
        subscriber.next(productsCatResponse);
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while deleting products master data", error);
      }
    );
  });
};

export const combineProducts = (selectedProducts: {}, queryParams?: Array<{
  key: AgTechQueryParam;
  value: boolean[] | string[];
}>): Observable<any> => {

  let deleteRequestsObservableList: Observable<any>[] = [];

  deleteRequestsObservableList = Object.keys(selectedProducts).map((productId) => 
    deleteProduct(productId, queryParams).pipe(
      catchError((error: any) => {
        return of({ error, productId });
      })
    )
  );

  if (deleteRequestsObservableList.length > 0) {
    return new Observable((subscriber) => {
      forkJoin(deleteRequestsObservableList).subscribe({
        next: (response: (IProduct | { error: any; productId: string })[]) => {
          subscriber.next(response);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
        },
        complete: () => {
          console.info("complete");
        },
      });
    });
  }
  return of([]);
};
